import script from "./TeamProjectsCell.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamProjectsCell.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__